module.exports = __webpack_public_path__ + "img/sale-tag.f075ec6f.svg";